import { LoginOutlined, UserOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import { programLabels } from '@/config';
import { getManufacturerByProgram } from '@/libs/util';
import useGlobalConfig from '@/store/global';

import Alphanine from './alphanine';
import Coagadex from './coagadex';
import Gammaked from './gammaked';
import Gamunex from './gamunex';
import Kedrab from './kedrab';
import Prolastin from './prolastin';
import Xembify from './xembify';

const Introduction = () => {
  const { program, themeColor } = useGlobalConfig();
  const name = program.name;

  const Content = () => {
    switch (name) {
      case 'alphanine':
        return <Alphanine />;
      case 'coagadex':
        return <Coagadex />;
      case 'gammaked':
        return <Gammaked />;
      case 'gamunex':
        return <Gamunex />;
      case 'kedrab':
        return <Kedrab />;
      case 'prolastin':
        return <Prolastin />;
      case 'xembify':
        return <Xembify />;
      default:
        return null;
    }
  };

  return (
    <div className="pb-10">
      <div className="text-xl md:text-3xl font-bold text-[#000000]">
        <span style={{ color: themeColor }}>Patient Account Portal</span>
      </div>
      <p className="my-2">Check your copay account status</p>

      <Content />

      <div className="my-10">
        <Button
          type="primary"
          icon={<UserOutlined />}
          size="large"
          style={{ backgroundColor: themeColor, borderColor: themeColor }}
          onClick={() => (window.location.href = '/patient/signup')}
        >
          New Patient Registration
        </Button>
        <Button
          type="primary"
          icon={<LoginOutlined />}
          size="large"
          className="ml-10"
          style={{ backgroundColor: themeColor, borderColor: themeColor }}
          onClick={() => (window.location.href = '/patient/signin')}
        >
          Returning Patient Login
        </Button>
      </div>

      <div>
        This program is subject to change or discontinuation by&nbsp;
        <b>{getManufacturerByProgram(name)}</b>
        &nbsp;at any time, for any reason, and with or without prior notice. This portal is
        administered by&nbsp;
        <a target="_blank" href="https://medmonk.com/" className="text-blue-500 hover:underline">
          Medmonk
        </a>
        &nbsp;for the {programLabels[name].label} Program.
      </div>
    </div>
  );
};

export default Introduction;
